export interface NewsArticle {
  title: string;
  description: string;
  image: string;
  date: string;
  tags: string[];
  subtitle?: string;
}

export interface StrapiNewsArticle {
  id: number;
  attributes: {
    title: string;
    description: string;
    subtitle?: string;
    date: string;
    publishedAt: string;
    image: {
      data: {
        attributes: {
          url: string;
        };
      };
    };
    tags: string[];
  };
}

export const mapStrapiArticle = (article: StrapiNewsArticle): NewsArticle => ({
  title: article.attributes.title,
  description: article.attributes.description ?? "",
  subtitle: article.attributes.subtitle,
  image: article.attributes.image?.data?.attributes?.url ?? "",
  date: new Date(article.attributes.date ?? article.attributes.publishedAt).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }),
  tags: article.attributes.tags ?? [],
});
